
import { Component } from "vue-property-decorator";
import { Vue, Prop} from "vue-property-decorator";
import PencilButton from "@/components/buttons/PencilButton.vue"

@Component({
    components: {
        PencilButton
    }
})
export default class StainLineItem extends Vue {

  infoClick() {
    this.$emit("stainInfoClick")
  }

  
  editClick() {
      this.$emit("editStainClick")
  }

}



